<template>
  <div :class="$style['m-menu']">
    <span :class="$style.trigger" @click.stop="toggleMenu"></span>

    <DropDwonMenu v-if="showMobileMenu" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DropDwonMenu from './DropDownMenu'

export default {
  name: 'TopBarMenuMobile',
  components: { DropDwonMenu },
  computed: mapState(['showMobileMenu']),
  methods: {
    toggleMenu () {
      this.$store.commit('SET_MOBILE_MENU', !this.showMobileMenu)
    }
  }
}
</script>

<style lang="scss" module>
.m-menu {
  position: relative;

  .trigger {
    display: inline-block;
    width: 24px;
    height: 24px;
    background: url(./assets/dots.svg) no-repeat 50% #fff;
    background-size: 24px;
    vertical-align: middle;
    outline: none;
    margin-right: 12px;
  }
}
</style>
